<template>
  <div class="tenantMuti">
    <Tooltip content="将浏览到所选的项目资源" placement="bottom-end">
      <span>浏览：</span>
    </Tooltip>
    <Dropdown trigger="custom" :visible="visible" transfer placement="bottom-end">
      <a href="javascript:void(0)" @click="handleOpen">
        <span v-for="(item, index) in $store.state.user.tenants" v-if="selTenants.indexOf(item.id) > -1 && index < 2" :key="item.id"><span v-if="index === 1">、</span>{{ item.name }}</span>
        <span v-if="selTenants.length > 2">...</span>
        <span> ({{ selTenants.length }})</span>
        <Icon :size="18" type="md-arrow-dropdown"></Icon>
      </a>
      <DropdownMenu slot="list" style="max-width: 400px" class="dropdown-div" ref="dropdownDiv">
        <div style="padding: 10px" class="tenant-muti-select">
          <div style="padding-bottom: 5px">
            <b>选择要浏览资源的项目：</b>
          </div>
          <Select v-model="provisionalSelect" multiple transfer filterable clearable style="min-width: 350px;" ref="tenantMutipleSelect" class="sel-div">
            <Option v-for="item in $store.state.user.tenants" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
        <div style="float: left; margin:10px;">
          <Button style="margin-right: 5px" size="small" @click="provisionalSelect = $store.state.user.tenants.map(item => item.id)">全选</Button>
          <Button size="small" @click="$refs.tenantMutipleSelect.clearSingleSelect()">清空</Button>
        </div>
        <div style="float: right; margin:10px;">
          <Button type="primary" @click="handleSave" size="small" style="margin-right: 5px">保存</Button>
          <Button type="default" @click="visible = false" size="small">取消</Button>
        </div>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getSelTenants } from '@/libs/util'
export default {
  name: 'TenantMuti',
  data () {
    return {
      provisionalSelect: [],
      selTenants: getSelTenants(),
      visible: false
    }
  },
  watch: {
    '$store.state.user.tenants' () {
      this.selTenants = getSelTenants()
    }
  },
  methods: {
    ...mapActions([
      'handleSelTenants'
    ]),
    selectChange (value) {
      if (this.selTenants.length === 0) {
        this.selTenants = [this.$store.state.user.defaultTenant]
        this.handleSelTenants(this.selTenants)
        this.$Notice.warning({
          title: '至少选择一个租户'
        })
      } else {
        this.handleSelTenants(value)
        this.$emit('reload')
      }
    },
    handleOpen () {
      if (!this.visible) {
        this.provisionalSelect = this.selTenants
      }
      this.visible = !this.visible
    },
    handleSave () {
      if (!this.provisionalSelect.length) {
        this.$Notice.warning({
          title: '至少选择一个租户'
        })
        return
      }
      this.selTenants = this.provisionalSelect
      this.visible = false
      this.selectChange(this.selTenants)
    }
  }
}
</script>

<style lang="less">
  .tenant-muti-select {
    padding: 0;
    overflow-y: auto;
    max-height: 250px;
    padding-bottom: 5px;
  }
  .tenant-muti-select::-webkit-scrollbar {
    width: 5px;
  }
  .tenant-muti-select::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .tenant-muti-select::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
